import { useRef, useState, useMemo, useEffect } from 'react';

const UPDATE_INTERVAL_MS = 1000 * 60;
const HALF_OF_HOUR = 30 * 60 * 1000;
const THRESHOLD_IN_MINUTES = 30;

const useTimeRange = () => {
  const timeIntervalRef = useRef(null);
  const [currentTimeMs, setCurrentTimeMs] = useState(Date.now());

  const result = useMemo(() => {
    const start = new Date(currentTimeMs);
    const m = start.getMinutes() > THRESHOLD_IN_MINUTES ? 30 : 0;
    start.setMinutes(m);
    start.setSeconds(0);
    start.setMilliseconds(0);
    const sheetStartTimeMs = start.getTime();
    const sheetEndTimeMs = new Date(sheetStartTimeMs + HALF_OF_HOUR * 4).getTime();

    return { sheetStartTimeMs, sheetEndTimeMs, currentTimeMs };
  }, [currentTimeMs]);

  useEffect(() => {
    const timeUpdate = () => setCurrentTimeMs(Date.now());

    timeIntervalRef.current = window.setInterval(timeUpdate, UPDATE_INTERVAL_MS);

    return () => window.clearInterval(timeIntervalRef.current);
  }, []);

  return result;
};

export default useTimeRange;
